import { ref, uploadBytesResumable, type UploadTask } from 'firebase/storage'
import { storage } from './firebase.js'

export interface UploadProgress {
  bytesTransferred: number
  totalBytes:       number
  percent:          number
}

export function resumableStorageUpload(
  storagePath: string,
  file:        Blob | File,
  contentType: string,
  onProgress?: (p: UploadProgress) => void,
): { task: UploadTask; promise: Promise<void> } {
  const storageRef = ref(storage, storagePath)
  const task = uploadBytesResumable(storageRef, file, { contentType })
  const promise = new Promise<void>((resolve, reject) => {
    task.on('state_changed',
      (snap) => onProgress?.({
        bytesTransferred: snap.bytesTransferred,
        totalBytes:       snap.totalBytes,
        percent:          Math.round((snap.bytesTransferred / snap.totalBytes) * 100),
      }),
      reject,
      resolve,
    )
  })
  return { task, promise }
}
